import type { ComponentExposed } from "vue-component-type-helpers"
import type R3Input from "~/components/R3/R3Input.vue"




export class LoginForm {
	inputUser = ref<ComponentExposed<typeof R3Input> | null>(null);
	inputPassword = ref<ComponentExposed<typeof R3Input> | null>(null);


}